import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mark-classification',
  templateUrl: './mark-classification.component.html',
  styleUrls: ['./mark-classification.component.css']
})
export class MarkClassificationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
